export default __webpack_public_path__ + "static/CHEMICAL RESISTANT LAMINATES-f66f5ca338f3d2925ba55da73b8d5874.webp";